// extracted by mini-css-extract-plugin
module.exports = {"title":"LayerStylingLabelsSettings_title__3SzuR"};